export default "__VITE_ASSET__z31$2N8m__"